import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import Driver from "../../../shared/models/driverModel";
import Vehicle from "../../../shared/models/vehicleModel";
import Occupation from "../../../shared/models/occupationModel";
import Qualification from "../../../shared/models/qualificaitonModel";
import NcdDetails from "../../../shared/models/ncdDetailsModel";
import Cover from "../../../shared/models/coverModel";
import Address from "../../../shared/models/addressModel";
import { TAXI_QUOTE_SOB } from "../../../config/config";

const uberConsentDate = new Date().toISOString();

const initialQuote = {
  brandRef: "DITXWEB",
  quoteNumber: null,
  risk: {
    drivers: [
      new Driver(
        {
          titleId: null,
          genderId: "",
          forename: null,
          initials: null,
          surname: null,
          emailAddress: null,
          telephone: null,
          businessTelephone: null,
          dateOfBirth: null,
          maritalStatusId: null,
          licenceNumber: null,
          datePassedTest: "2008-01-01T00:00:00",
          licenceTypeId: null,
          licenceRestrictionsId: null,
          licenceCountryOfIssue: "023",
          relationshipId: "P",
          uberDriverRatingId: null,
          ukResidenceYears: null,
          residentSinceBirth: null,
          mainUser: true,
          motoringOrganisationId: "UBCL",
          driverPostcode: null,
          uberDriverId: "UBER_TEST_USER_2_BRAMWELL",
          insuranceCancelled: false,
          criminalConvictions: null,
          objectId: "",
          objectHistoryId: 1,
          medicalConditions: null,
        },
        new Address("", "", "", "", "", "", "", "", 0),
        [new Occupation(null, null, null, null, "", "", 0)],
        [],
        null,
        [new Qualification(null, null, "", "", 0)],
        null,
      ),
    ],
    vehicles: [
      new Vehicle(
        {
          abiCode: "0",
          annualMileage: 0,
          bodyTypeId: null,
          businessMileage: 0,
          cctv: false,
          colourId: null,
          countryOfFirstRegistrationId: "0",
          // coverTypeId: null,
          coverTypeId: "01",
          cubicCapacity: 0,
          currentMileage: 0,
          estimatedValue: null,
          exteriorCameraDetails: null,
          fuelTypeId: null,
          gearboxId: null,
          gvw: 0,
          hackneyCarriage: false,
          havePreviousRegistration: null,
          imported: null,
          interiorCamera: null,
          keeperId: null,
          licensingPlateNumber: null,
          make: null,
          model: null,
          ncdEntitlementReasonId: null,
          noOfSeats: null,
          objectId: "",
          operatingArea: null,
          operatingPostcode: null,
          overnightParkingId: null,
          ownerId: null,
          parentObjectHistoryId: 0,
          parentObjectId: "",
          permanentReferenceNumber: 0,
          personalisedPlate: false,
          preVehicleSearch: null,
          preVehicleSearchSuccess: null,
          previousVehicleOwned12Month: false,
          pricePaid: 0,
          purchaseDate: null,
          qPlated: false,
          qPlatedReasonId: null,
          registeredDate: null,
          registrationNumber: null,
          rightHandDrive: null,
          selfModified: null,
          series: null,
          securityDevices: null,
          modifications: null,
          uberVehicleId: null,
          usedForContractWork: false,
          vehicleGrouping: null,
          yearOfManufacture: null,
          otherNcdDetails: null,
        },
        new NcdDetails(null, null, null),
        new Address("", "", "", "", "", "", "", "", 0),
      ),
    ],
    cover: new Cover("", 0, "00", null, "", 0),
    startDate: null,
    sourceOfBusinessId: TAXI_QUOTE_SOB,
    campaignId: "0", 
    activityId: "0",
    riskObjectId: null,
    riskObjectHistoryId: 1,
    uberMetrics: {
      lifetime_completed_trips: "0",
      driver_rating: "less_than_or_equal_50_trips",
      uber_pro_tier: "Blue",
    },
    uberConsent: {
      uberConsentStatus: "UberConsentGiven",
      uberConsentDate: uberConsentDate,
    },
  },
};

const useQuoteStore = create()(
  persist(
    (set) => ({
      quote: initialQuote,

      updateField: (path, value) =>
        set((state) => {
          const keys = path.split(".");
          const lastKey = keys.pop();
          let target = state.quote;

          for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const nextKey = keys[i + 1];

            if (!(key in target) || target[key] === null) {
              target[key] = isNaN(nextKey) ? {} : [];
            }

            target = target[key];

            if (Array.isArray(target) && nextKey !== undefined) {
              const index = parseInt(nextKey, 10);
              if (!target[index]) {
                target[index] = {};
              }
            }
          }

          target[lastKey] = value;

          return { quote: { ...state.quote } };
        }),

      setQuote: (quote) => {
        set(() => ({
          quote: quote,
        }));
      },

      reset: () => {
        set({ quote: initialQuote });
      },
    }),
    {
      name: "quote-store",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useQuoteStore;
